import React, { useState } from 'react';
import Card from '../../UI/Card/Card';
import MySelect from '../../UI/select/MySelect';
import MyButton from '../../UI/button/MyButton';
import { useDMSContext } from '../../context/DMSContext';
import '../../assets/css/ReportsSections.css';
import CustomDatePicker from '../CustomDatePicker';
import { FaFileCsv, FaFileExcel, FaFilePdf } from "react-icons/fa";
import reportService from '../../services/ReportService';
import { useEffect } from 'react';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';

export default function ReportsSection() {
  const { debtors } = useDMSContext();

  const [loading, setLoading] = useState(false);

  const [reportType, setReportType] = useState(null);
  const [selectedDebtors, setSelectedDebtors] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const reportOptions = [
    { value: 'aging', label: 'Raport Restanțe pe Vechime' },
    { value: 'collections', label: 'Raport Colectări pe Perioadă' },
    { value: 'highRisk', label: 'Raport Debitori cu Risc Ridicat' },
    { value: 'contracts', label: 'Raport Sumar Contracte' },
  ];

  const debtorOptions = debtors.map(d => ({ value: d.id, label: d.name }));

  const handleExport = async (format) => {
    if (!reportType) {
      alert("Selectează tipul raportului înainte de export!");
      return;
    }
    if ((reportType === 'aging' || reportType === 'collections' || reportType === 'highRisk' || reportType === 'contracts') 
        && selectedDebtors.length === 0) {
      alert("Selectează cel puțin un debitor!");
      return;
    }
  
    const payload = {
      reportType,
      startDate: startDate ? startDate.toISOString().split("T")[0] : null,
      endDate: endDate ? endDate.toISOString().split("T")[0] : null,
      debtors: selectedDebtors.map((d) => d.value),
    };
  
    try {
      setLoading(true);
      const blob = await reportService.exportReport(format, payload);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `raport_${reportType}.${format}`;
      a.click();
    } catch (err) {
      console.error("Export error:", err);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className='dms-content'>
      <div className='section-header'><h2>Rapoarte Financiare & Operaționale</h2></div>

      <Card>
  <h3>Filtre Raport & Export</h3>
  <div className="form-container">

    <div className="filter-item">
      <label>Tip raport</label>
      <MySelect
        options={reportOptions}
        value={reportOptions.find(r => r.value === reportType)}
        onChange={(selectedOption) => setReportType(selectedOption)}
        placeholder="Selectează tipul raportului"
      />
    </div>

    {(reportType === 'collections' || reportType === 'aging') && (
      <div className="filter-item">
        <label>Perioadă</label>
        <div className="date-range">
          <CustomDatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            placeholderText="Data început"
            dateFormat="dd.MM.yyyy"
          />
          <CustomDatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            placeholderText="Data sfârșit"
            dateFormat="dd.MM.yyyy"
          />
        </div>
      </div>
    )}

    {(reportType === 'aging' || reportType === 'collections' || reportType === 'highRisk'  || reportType === 'contracts') && (
      <div className="filter-item">
        <label>Debitori</label>
        <MySelect
          isMulti
          options={debtorOptions}
          value={selectedDebtors}
          onChange={(opts) => setSelectedDebtors(opts)}
          placeholder="Selectează debitorii"
        />
      </div>
    )}

    <div className="export-buttons">
      <MyButton 
        size="small" 
        icon={<FaFileCsv />} 
        body="CSV" 
        className="btn-csv"
        onClick={() => handleExport('csv')} 
        disabled={!reportType || loading}
      />
      <MyButton 
        size="small" 
        icon={<FaFileExcel />} 
        body="Excel" 
        className="btn-excel"
        onClick={() => handleExport('xlsx')} 
        disabled={!reportType || loading}
      />
      <MyButton 
        size="small" 
        icon={<FaFilePdf />} 
        body="PDF" 
        className="btn-pdf"
        onClick={() => handleExport('pdf')} 
        disabled={!reportType || loading}
      />
    </div>
  </div>
</Card>
<CircleSpinnerOverlay 
  loading={loading} 
  overlayColor="rgba(0, 0, 0, 0.8)" 
  color="#1b1b1bff" 
/>

    </div>
  );
}
